import React from "react"

import Layout from "../components/layout"
import SEO from "../components/seo"
import Image from "../components/Image"
import Footer from "../components/Footer"
import "../components/index.scss"

import { Link } from "gatsby"

const IndexPage = () => (
  <Layout>
    <SEO title="Home" />
    <link
      href="https://fonts.googleapis.com/css?family=Marcellus&display=swap"
      rel="stylesheet"
    />
    <header>
      <div className="image-container">
        <Image
          filename={"landing-page/logo.png"}
          customCSS={{
            maxWidth: "350px",
            margin: "auto",
            marginTop: "20px",
            marginBottom: "30px",
          }}
        />
      </div>
    </header>

    <div style={{ textAlign: "center" }}>
      <div className="how-does-it-work">
        <h2>Besoin d’un site web ?</h2>
        <p>
          Mon.Rest vous offre un site web adapté aux besoins d’un restaurant
          pour juste €199/an.
        </p>
      </div>

      <div className="advantages">
        <h2>Mon.Rest vs. Agence Web</h2>
        <div className="advantages__section">
          <span className="advantages__text">Prêt à l'emploi</span>
        </div>

        <div className="advantages__section">
          <span className="advantages__text">
            Pas de frais de mise en place
          </span>
        </div>

        <div className="advantages__section">
          <span className="advantages__text">Pas besoin de nom de domaine</span>
        </div>

        <div className="advantages__section">
          <span className="advantages__text">Pas de frais de mise à jour</span>
        </div>

        <div className="advantages__section">
          <span className="advantages__text">Pas de frais d’hébergement</span>
        </div>
        {/* 
        <div className="advantages__section">
          <span className="advantages__text">€99 vs. ~€1800</span>
        </div> */}
      </div>

      <div className="example">
        <h2 className="example-title">Comment ça marche ?</h2>
        <p>
          Vous nous donnez les informations et les photos, et nous vous
          fournissons un site Mon.Rest
        </p>
        <p>Exemples de sites web réalisés avec Mon.rest:</p>
        <div className="example-container">
          <Link to="/pizzo" className="example-link">
            Pizzo
          </Link>
          <Link to="/ikko-salad" className="example-link">
            Ikko Salad
          </Link>
          <Link to="/gourmet-paris" className="example-link">
            Gourmet Paris
          </Link>
        </div>
      </div>

      <div className="contact">
        <div className="contact-question">
          <p>Intéressé ?</p>
          <p>Question ?</p>
          <p>Commentaires ?</p>
        </div>
        <p>N'hésitez pas à nous contacter</p>
        <p className="contact-email">contact@mon.rest</p>
      </div>

      <Footer rest={{ color: [9, 47, 70] }} />
    </div>
  </Layout>
)

export default IndexPage
